<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>名称：</label>
                        <el-input v-model="search_Obj.f_group_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="group_name" label="集团名称" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <ItemList
                    width="800px"
                    :group_id="model_id"
                    :isshow="item_show"
                    @on-close="closeItemDialog">
                </ItemList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import ItemList from "./itemlist"
import listutil from "@/libs/listutil"

export default {
    name: 'projectGroupList',
    mixins: [listutil],
    components: {Edit, ItemList, Btns, LabBtns},
    data() {
        return {
            m_name: '集团',
            menu_id: 1110,
            list_url: "/api/admin/projectgroup/list",
            search_Obj: {
                f_group_name: '',
            },
            del_Obj:{
                url:'/api/admin/projectgroup/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            item_show: false,
        };
    },
    methods: {
        item(index, row){
            this.model_id = row.id
            this.item_show = true
        },
        closeItemDialog(){
            this.item_show = false
        }
    }
};
</script>